import React from "react";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import { IBoardState, IMultipleShorting } from "../types";
import { formatLabel } from "../../../helpers";

export const boardsTicketShortFields = [
  { key: "ticketName", label: "Ticket Name" },
  { key: "status", label: "Status" },
  { key: "dueDate", label: "Due Date" },
  { key: "priority", label: "Priority" },
];

export const renderFormValue = (
  form: IBoardState,
  val: string,
  loadingLboolean: boolean,
  ticketType: ITicketTypes[],
  hasVisibleGroup: number,
  totalGroups: number,
) => {
  const renderLoading = () => {
    return (
      <div className="animate-pulse w-[80px] h-[12px]">
        <div className="size-3 rounded bg-gray-400  border-[transparent] px-[6px] w-full"></div>
      </div>
    );
  };
  switch (val) {
    case "viewType":
      return loadingLboolean ? renderLoading() : form.viewType;
    case "groupBy":
      return loadingLboolean ? renderLoading() : formatLabel(form?.groupBy);
    case "visibleGroups":
      return loadingLboolean
        ? renderLoading()
        : `${hasVisibleGroup} of ${totalGroups}`;
    case "subGroupBy":
      return loadingLboolean ? renderLoading() : formatLabel(form?.subGroupBy);
    case "permission":
      return loadingLboolean ? renderLoading() : form.permission;
    case "defaultTicketType":
      return loadingLboolean
        ? renderLoading()
        : ticketType?.find((item) => item?._id === form?.defaultTicketType)
            ?.name;
    default:
      return;
  }
};
